export const useFormat = (text: string | undefined | null) => {
  //check for spesific caracter
  return text?.replaceAll(/(®|&reg;)/g, '<sup>®</sup>')
}
